import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Crater2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CRATER2;
}

export default Crater2PoiTileEntity;
